import { SelectOptionsProps } from '@/shared/types/shared-types/select.type';
import moment from 'moment-timezone';
import _ from 'lodash';
import { PurchaseOrderReportUIFilters } from '@/shared/ui-models/purchase-order-report.ui-model';
import { PurchaseOrderSearchQuery } from '@/shared/ui-models/purchase.ui-model';

export const findOptionById = (options: SelectOptionsProps[], id: string) =>
  _.find(options, { id });

type OptionsType = {
  statusSelectOptions: SelectOptionsProps[];
};

export const mapValuesToQuery = (
  values: PurchaseOrderSearchQuery,
  options: OptionsType
): PurchaseOrderReportUIFilters => {
  const { startDate, endDate, status, autoProfitMarginFrom, autoProfitMarginTo, ...rest } = values;

  return {
    ...rest,
    ...(startDate && { startDate: moment(startDate) }),
    ...(endDate && { endDate: moment(endDate) }),
    ...(status && {
      status:
        Array.isArray(status) && typeof status[0] === 'string'
          ? (status
              .map((id) => findOptionById(options.statusSelectOptions, id))
              .filter(Boolean) as SelectOptionsProps[])
          : status
    }),
    ...(autoProfitMarginFrom && { autoProfitMarginFrom: autoProfitMarginFrom }),
    ...(autoProfitMarginTo && { autoProfitMarginTo: autoProfitMarginTo })
  };
};

export const mapFiltersToApiQuery = (
  filters: PurchaseOrderReportUIFilters
): PurchaseOrderSearchQuery => {
  const { startDate, endDate, status, autoProfitMarginFrom, autoProfitMarginTo } = filters;
  const apiQuery: PurchaseOrderSearchQuery = {};

  if (startDate || endDate) {
    apiQuery.lastUpdatedAt = {
      from: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
      to: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined
    };
  }

  if (status && status.length) {
    apiQuery.status = status.map((s) => s.id);
  }

  if (autoProfitMarginFrom || autoProfitMarginTo) {
    apiQuery.autoProfitMargin = {
      from: autoProfitMarginFrom ? Number(autoProfitMarginFrom) : undefined,
      to: autoProfitMarginTo ? Number(autoProfitMarginTo) : undefined
    };
  }

  return apiQuery;
};
